// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EmbeddedYTVideo_wrapper__3jQ07","videoContainer":"EmbeddedYTVideo_videoContainer__x9Bh4"};